// trame.helper.ts
import { ValidatorFn, AbstractControl } from "@angular/forms";

export class TrameHelper {
  static readonly NEW_LINE = "\n";
  static readonly EMPTY_STRING = "";

  static validateTrameCompletion(trame: string): ValidatorFn {
    return (control: AbstractControl) => {
      const lines = trame.split(this.NEW_LINE);
      const inputLines = (control.value || this.EMPTY_STRING).split(this.NEW_LINE);

      for (let i = 0; i < lines.length; i++) {
        const prefix = lines[i].trim();
        const userLine = (inputLines[i] || this.EMPTY_STRING).trim();

        if (!userLine.startsWith(prefix) || userLine === prefix) {
          return { incompleteTrame: true };
        }
      }
      return null;
    };
  }

  static applyTramePrefix(currentValue: string, trame: string): string {
    const trameLines = trame.split(this.NEW_LINE);
    const inputLines = currentValue.split(this.NEW_LINE);

    const updatedLines = inputLines.map((line, index) => {
      const prefix = trameLines[index] ? trameLines[index].trim() : null;
      if (prefix && !line.startsWith(prefix)) {
        return `${prefix} `;
      }
      return line;
    });

    return updatedLines.join(this.NEW_LINE);
  }

  static getProtectedLength(trame: string): number {
    const trameLines = trame.split(this.NEW_LINE);
    return trameLines.length ? trameLines[0].length : 0;
  }
}
